import React, { useState } from 'react'
import { Modal } from 'oio-react'
import Helmet from 'react-helmet'
import { Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import { useOrganization, usePage } from 'src/graphql/hooks'
import PageContext from '~/Page/libraries/context'
import PageSettings from '~/Page/pages/Settings'
import PageView from '~/Page/pages/View'
import PageVisualEditor from '~/Page/pages/VisualEditor'

const Page = () => {
   const history = useHistory()
   const { pageSlug } = useParams()
   const match = useRouteMatch()
   const [modalIsOpen, setModalIsOpen] = useState(true)

   const pageQueryOptions = {
      withContent: true
   }

   // TODO: DEPRECATE WHEN WE COMBINE SLUGS AND URLS
   // The substring below is to remove the leading slash that comes from
   // the match url from useRouteMatch
   // See PR #285
   if (match.url.startsWith('/pages')) {
      pageQueryOptions.slug = pageSlug
   } else {
      pageQueryOptions.url = match.url.substring(1)
   }

   const { page, loading: pageIsLoading } = usePage(pageQueryOptions)
   const { organization } = useOrganization()
   const { currentUserCanEdit } = organization

   if (pageIsLoading) {
      return null
   }

   return (
      <PageContext.Provider value={page}>
         <Helmet title={`${page.title} | ${organization.name}`} />
         <PageView />
         {currentUserCanEdit && (
            <Switch>
               <Route path={`${match.path}/edit`}>
                  <Modal
                     borderRadius="6px"
                     width="100%"
                     height="100%"
                     onCloseComplete={() => {
                        history.push(match.url)
                        setModalIsOpen(true)
                     }}
                     onCloseTrigger={() => setModalIsOpen(false)}
                     openAnimationName="fadeIn"
                     open={modalIsOpen}>
                     <PageVisualEditor returnUrl={match.url} />
                  </Modal>
               </Route>
               <Route path={`${match.path}/settings`}>
                  <Modal
                     borderRadius="6px"
                     width="100%[a-d] 1200px[e-f]"
                     height="100%[a-d] 85%[e-f]"
                     onCloseComplete={() => {
                        history.push(match.url)
                        setModalIsOpen(true)
                     }}
                     onCloseTrigger={() => setModalIsOpen(false)}
                     open={modalIsOpen}>
                     <PageSettings returnUrl={match.url} />
                  </Modal>
               </Route>
            </Switch>
         )}
      </PageContext.Provider>
   )
}

export default Page
